import React from "react";
import { OutSideClickProps } from "./types";

export default function useOnOutSideClick({ node, onOutSideClick }: OutSideClickProps) {
  React.useEffect(() => {
    function handleOutSideClick(event: any) {
      const isClickInside = node?.contains(event.target);
      if (!isClickInside) {
        onOutSideClick();
      }
    }
    document.addEventListener("click", handleOutSideClick);
    return () => {
      document.removeEventListener("click", handleOutSideClick);
    };
  }, [node, onOutSideClick]);
}
